import React,{useState,useEffect} from 'react';
import { DeleteOnboardService, GetOnboardListService, UpdateOnboardService } from '../../services/OnboardServices';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import {AiOutlineDelete, AiOutlineEdit} from 'react-icons/ai';
import SettingsMenu from '../staticscreens/SettingsMenu';
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button';
import {MdPassword} from 'react-icons/md';
import { Modal } from 'antd';
import { TextInput } from '../../components/input';
import {  GetSearchService, UpdateUserPasswordService } from '../../services/AuthServices';
import { toast } from 'react-hot-toast';
import {FiChevronRight,FiChevronLeft} from 'react-icons/fi';
import { IconButton } from '@mui/material'
import {BsArrowRepeat} from 'react-icons/bs';

function OnboardList() {
  
  const [page,setpage] = useState(1)
  const [data,setdata] = useState([])  
  const [imageErrorMap,setimageErrorMap] = useState({})
  const [selectedData,setselectedData] = useState({})
  const [delete_modal,setdelete_modal] = useState(false)
  const [modal,setmodal] = useState(false)
  const [filterApplied,setfilterApplied] = useState(false)
  const [search,setsearch] = useState('')
  const navigate = useNavigate() 

  const [password,setpassword] = useState('')
  const [error,seterror] = useState('')


  useEffect(()=>{
    if(filterApplied){
      searchfunction()
    }else{
        getOnboardList()
    }
  },[page])  

  
  async function getOnboardList(){
    console.log("1")
      const response = await GetOnboardListService(page);
    // console.log("err",response)
      setdata(response.data)
  }

  async function updatePassword(){
    if(password.length < 8){
       seterror('Password Shoild be atleast 8 characters')
    }else{
      let send_Data = {
        'user_id':selectedData?._id,
        'password':password
      }
      const response = await UpdateUserPasswordService(send_Data)
      if(response.status === 200){
        setpassword('')
        seterror('')
        setmodal(false)
        toast.success(response?.data?.message)
      }
    }
  }

  async function searchfunction(){
    if(search.length < 3){

    }else{
      const response = await GetSearchService(search,page)
      setdata(response.data)
      setfilterApplied(true)
    }
    
  }

  function setpasswordfunc(e){
    setpassword(e.target.value)
    seterror('')
  }

  async function resetfunc(){
    setpage(1)
    setfilterApplied(false)
    getOnboardList()
    setsearch('')
  }

  async function deleteData(){
  const response = await DeleteOnboardService(selectedData?._id)
  if(response?.status === 200){
    getOnboardList()
    setdelete_modal(false)
    toast?.success("Deleted Successfully")
    setselectedData({})
  }else{
    getOnboardList()
    setdelete_modal(false)
    toast?.success("Deleted Successfully")
    setselectedData({})
  }
 }

 async function updateStatus(v,data) {
   const response = await UpdateOnboardService({online:!data.online},v)
   if(response?.status == 200){
    toast.success("Status Updated Successfully")
    getOnboardList()
   }
 }

  return (
    <div className='md:h-screen pt-5 md:pt-0 md:overflow-hidden'>     

      <Modal 
       open={modal}
       closable={false}
       footer={false}
       width={300}>
        <div className='relative'>
        <h6 className="font-bold text-[15px]  mb-2 w-full">Update Password</h6>
          <h6 className='bg-slate-100 text-[12px] p-1.5 font-[400]'>Are you sure to update the password for the employee who is having a name of <span className='font-[700]'>[{selectedData?.name}]</span>  who is having a designation of <span className='font-[700]'>[{selectedData?.designation_id?.length > 0 && selectedData?.designation_id[0]?.designation_name}]</span> </h6>

          <TextInput error={error} name="password" value={password} handlechange={setpasswordfunc} /> 
          <div className='flex justify-end mt-3 '>
            {/* <div className='mr-1 w-full'> */}
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={()=>setmodal(false)} />
            {/* </div> */}
            <div  className='ml-2'>
            <ButtonFilledAutoWidth btnName={'Confirm'} onClick={updatePassword}  /> 
            </div>
          </div>
        </div>
      </Modal>

      <Modal 
        open={delete_modal}
        closable={false}
        footer={false}
        width={300}>
        <div className='relative'>
        <h6 className="font-bold text-[15px] mb-2 w-full">Delete Data</h6>
        <h6 className='bg-slate-100 text-[12px] p-1.5 font-[400]'>Are you sure to want to delete the data of the <span className='font-[700]'>[{selectedData?.name}]</span> once deleted it will be not retrieved! </h6>

        <div className='flex justify-end mt-3 '>
        {/* <div className='mr-1 w-full'> */}
        <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={()=>setdelete_modal(false)} />
        {/* </div> */}
        <div className='ml-2'>
        <ButtonFilledAutoWidth btnName={'Confirm'} onClick={deleteData} /> 
 </div>
 </div>
 </div>
 </Modal>
      <div className='md:flex items-start'>
      <SettingsMenu />
      <div  className='md:w-[90%] px-4 pt-2 md:pt-2'>
       <div sx={{display:{sm:'none',xs:'none',lg:'block',md:'block'}}}>
        <div className='md:flex items-center justify-between border-b pb-2'>
        <div className='flex items-center justify-between'>
        <h6 className='font-[800] text-[14px] '>{'Our Employee'} ({data?.pagination?.total})</h6>

        <div className='flex'>

        <div className='flex md:hidden items-center  text-[12px] mr-2'>

        <h6 className='mr-2 font-[500]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit } - {data?.pagination?.limit} of {data?.pagination?.total} </h6>
        <IconButton onClick={resetfunc}><BsArrowRepeat size={16} /></IconButton>

        <div>
        <IconButton onClick={()=>{page > 1 ? setpage(page-1) : console.log('')}} ><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
        <IconButton onClick={()=>{ page < data?.pagination?.totalPages  ? setpage(page+1) : console.log('')}}><FiChevronRight className={`${data?.pagination?.totalPages === page ? 'opacity-50' : 'opacity-100'}`}  size={16} /></IconButton>

        </div>
        </div>
        </div>
        </div>

        <div className='flex items-center mt-2'>
        <div className='hidden md:flex items-center  text-[12px] mr-2'>

          <h6 className='mr-2 font-[500]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit } - {data?.pagination?.limit} of {data?.pagination?.total} </h6>
          <IconButton onClick={resetfunc}><BsArrowRepeat size={16} /></IconButton>

          <div>
          <IconButton onClick={()=>{page > 1 ? setpage(page-1) : console.log('')}} ><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
          <IconButton onClick={()=>{ page < data?.pagination?.totalPages  ? setpage(page+1) : console.log('')}}><FiChevronRight className={`${data?.pagination?.totalPages === page ? 'opacity-50' : 'opacity-100'}`}  size={16} /></IconButton>

          </div>
          </div>

        <div>
          
          <input id="search_text" placeholder='Search Employee' type='text' value={search}  onChange={(e)=>setsearch(e.target.value)} className='border text-sm py-[4px] focus:ring-0  focus:outline-0 text-[13px]  w-28 px-1 rounded-md border-slate-300' />
        </div>
        <div className="ml-2 flex">
        <ButtonOutlinedAutoWidth onClick={()=>{setpage(1);searchfunction()}}  btnName="Add Filter"  />

        <div className="ml-2">
        <ButtonFilledAutoWidth btnName="Add New" onClick={()=>navigate('create')}   />
        </div> 
        </div> 
        </div>

       </div>

       {data?.datas?.length === 0 &&
        <div className='grid place-items-center mt-20  items-center justify-center'>
        <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' /> 
        <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
        <h6 className='font-[500] text-center w-[70%] text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any "Employee" onboarded yet click on the add option to create a new employee for your organization.</h6>
       </div>
       }
       {data?.datas?.length !== 0 &&
       <>
       {/* Desktop / tablet table */}
       <div className='hidden md:block md:max-h-[85vh] md:overflow-auto border-t border-l border-r mt-2'>
       <div className='top-0 z-50 flex border-b w-full bg-white py-[-5px]  border-slate-200 relative'>
          <h6 className='text-[12px] truncate min-w-[50px] w-[50px]  px-2 py-1 font-[400] border-r'>Sl No</h6>
          <h6 className='text-[12px] truncate min-w-[50px] w-[50px]  px-2 py-1 font-[400] border-r capitalize'>Photo</h6>
          <h6 className='text-[12px] truncate min-w-[140px] w-[140px] px-2 py-1 font-[400] border-r capitalize'>Name</h6>
          <h6 className='text-[12px] truncate min-w-[100px] w-[100px] px-2 py-1 font-[400] border-r capitalize'>Phone</h6>
          <h6 className='text-[12px] truncate min-w-[160px] w-[160px] px-2 py-1 font-[400] border-r capitalize'>Email</h6>
          <h6 className='text-[12px] truncate min-w-[160px] w-[160px] px-2 py-1 font-[400] border-r capitalize'>Designation</h6>
          <h6 className='text-[12px] truncate min-w-[180px] w-[180px] px-2 py-1 font-[400] border-r capitalize'>Roles</h6>
          <h6 className='text-[12px] truncate min-w-[90px] w-[90px] px-2 py-1 font-[400] border-r capitalize'>Joined Date </h6>
          <h6 className='text-[12px] truncate min-w-[90px] w-[90px] px-2 py-1 font-[400] border-r capitalize'>Created On </h6>
          <h6 className='text-[12px] truncate min-w-[50px] w-[50px] px-1 py-1 font-[400] capitalize'>Action</h6>
       </div>


       {data?.datas?.map((d,i)=>(
       <div key={d?._id} className='flex  w-full border-b cursor-pointer z-0'  >
          <h6  onClick={()=>navigate('edit',{state:d?._id})} className='text-[11px] truncate min-w-[50px] w-[50px] text-center  px-2 py-1 truncate  border-r '>{page == 1 ? i+1 : ((page-1) + data?.pagination?.limit) + i+1}</h6>
          <h6  onClick={()=>navigate('edit',{state:d?._id})} className='text-[11px] truncate min-w-[50px] w-[50px] flex items-center justify-center py-1 truncate  border-r'>{(d?.profile_photo !== null && d?.profile_photo !== undefined && !imageErrorMap[d?._id]) ? <img className=" w-5 h-5 rounded object-contain" src={`${process.env.REACT_APP_AWS_IMAGE_URL}${d?.profile_photo}`} alt="Default avatar" onError={()=>setimageErrorMap((prev)=>({...prev,[d?._id]:true}))}></img> : <span className='bg-gray-100 w-5 h-5 flex items-center justify-center text-[10px] rounded uppercase font-[700]'>{d?.name?.slice(0,2)}</span>}</h6>
          <h6  onClick={()=>navigate('edit',{state:d?._id})} className='text-[11px] truncate min-w-[140px] w-[140px]  font-[600] px-2 py-1 truncate  border-r '>{d?.name} <br></br> <p className='text-[10px] break-all'> Employee Type : {d?.employement_type}</p></h6>
          <h6  onClick={()=>navigate('edit',{state:d?._id})} className='text-[11px] truncate min-w-[100px] w-[100px] px-2 py-1 truncate  border-r '>{d?.phone}</h6>
          <h6  onClick={()=>navigate('edit',{state:d?._id})} className='text-[11px] truncate min-w-[160px] w-[160px] font-[600] px-2 py-1 truncate  border-r '>{d?.email}</h6>
          <h6  onClick={()=>navigate('edit',{state:d?._id})} className='text-[11px] truncate min-w-[160px] w-[160px] px-2 py-1 truncate  border-r truncate'>{d?.designation_id[0]?.designation_name !== undefined && <span className='text-[9px] font-semibold py-1 px-2 uppercase rounded text-slate-800 break-all bg-slate-100 uppercase last:mr-0 mr-1'>{d?.designation_id[0]?.designation_name}</span>}</h6>
          <h6 className='text-[11px] truncate min-w-[180px] w-[180px] px-2 py-1 font-[500]   text-slate-800  border-r capitalize truncate'>{d?.user_roles?.map((r)=>(<span key={r?.roles?._id} className="text-[9px] font-semibold  py-1 px-2 uppercase rounded text-slate-800 bg-slate-100 uppercase last:mr-0 mr-1">{r?.roles?.display_name}</span>))}</h6>
          <h6  onClick={()=>navigate('edit',{state:d?._id})} className='text-[10px] truncate min-w-[90px] w-[90px] font-[600] px-2 py-1 truncate  border-r '>{moment(d?.doj).format('ll')}</h6>
          <h6  onClick={()=>navigate('edit',{state:d?._id})} className='text-[10px] truncate min-w-[90px] w-[90px] px-2 py-1 truncate  border-r '>{moment(d?.createdAt).format('ll')}</h6>
          <h6  className='text-[12px] truncate min-w-[100px] w-[100px] flex items-center justify-center '>
            <h6 onClick={()=>updateStatus(d?._id,d)}  className={`${d?.online ? 'bg-[#de9f19]' : 'bg-slate-200'} ml-1  p-1 text-[9.5px] rounded font-[500]`}>{d?.online ? 'Online' : 'Offline'}</h6>
            <AiOutlineEdit size={12} className="z-10 cursor-pointer ml-2" onClick={()=>navigate('edit',{state:d?._id})}/>
            <MdPassword  className='ml-2 cursor-pointer' size={12} onClick={()=>{setselectedData(d);setmodal(true)}} />
            <AiOutlineDelete size={12} className="ml-2  z-10 cursor-pointer" onClick={()=>{setselectedData(d);setdelete_modal(true)}}/>

          </h6>
       </div>))}
       </div>

       {/* Mobile card list */}
       <div className='md:hidden mt-2 space-y-2'>
        {data?.datas?.map((d,i)=>(
          <div key={d?._id} className='border rounded-md p-3 bg-white'>
            <div className='flex items-start justify-between'>
              <div className='flex items-center' onClick={()=>navigate('edit',{state:d?._id})}>
                {(d?.profile_photo !== null && d?.profile_photo !== undefined && !imageErrorMap[d?._id]) ? <img className="w-9 h-9 rounded object-contain mr-2" src={`${process.env.REACT_APP_AWS_IMAGE_URL}${d?.profile_photo}`} alt="Default avatar" onError={()=>setimageErrorMap((prev)=>({...prev,[d?._id]:true}))}></img> : <span className='bg-gray-100 w-9 h-9 flex items-center justify-center text-[12px] rounded uppercase font-[700] mr-2'>{d?.name?.slice(0,2)}</span>}
                <div>
                  <h6 className='text-[13px] font-[700]'>{d?.name}</h6>
                  <h6 className='text-[11px] text-slate-600'>{d?.phone}</h6>
                </div>
              </div>
              <div className='flex items-center -mr-1.5'>
                <span className='p-2 cursor-pointer'><AiOutlineEdit size={17} onClick={()=>navigate('edit',{state:d?._id})}/></span>
                <span className='p-2 cursor-pointer'><MdPassword size={17} onClick={()=>{setselectedData(d);setmodal(true)}} /></span>
                <span className='p-2 cursor-pointer'><AiOutlineDelete size={17} onClick={()=>{setselectedData(d);setdelete_modal(true)}}/></span>
              </div>
            </div>

            <h6 className='text-[11px] mt-1'>Employee Type : {d?.employement_type || '-'}</h6>
            {d?.email && <h6 className='text-[11px] mt-1 break-all'>{d?.email}</h6>}

            <div className='flex flex-wrap mt-2 items-center gap-1'>
              <h6 onClick={()=>updateStatus(d?._id,d)} className={`${d?.online ? 'bg-[#de9f19]' : 'bg-slate-200'} px-1.5 py-1 text-[10px] rounded font-[600]`}>{d?.online ? 'Online' : 'Offline'}</h6>
              {d?.designation_id[0]?.designation_name !== undefined && <span className='text-[10px] font-semibold py-1 px-2 uppercase rounded text-slate-800 bg-slate-100'>{d?.designation_id[0]?.designation_name}</span>}
              {d?.user_roles?.map((r)=>(<span key={r?.roles?._id} className="text-[10px] font-semibold py-1 px-2 uppercase rounded text-slate-800 bg-slate-100">{r?.roles?.display_name}</span>))}
            </div>

            <h6 className='text-[10px] font-[400] bg-slate-100 rounded mt-2 p-1'>Joined : {moment(d?.doj).format('ll')} &middot; Created : {moment(d?.createdAt).format('ll')}</h6>
          </div>
        ))}
       </div>
       </>}
       </div>

      



      </div>
      </div> 
    </div>
  )
}

export default OnboardList